import { GraphQLProviderProps } from '@graphcommerce/graphql'
import type { PluginProps } from '@graphcommerce/next-config'

export const component = 'GraphQLProvider'
export const exported = '@graphcommerce/graphql'

function TempliCartGraphqlProvider(props: PluginProps<GraphQLProviderProps>) {
  const { Prev, policies = [], ...rest } = props
  const adjustedPolices = [...policies].map((policy) => {
    if (
      typeof policy?.Cart?.fields?.shipping_addresses === 'object' &&
      'merge' in policy.Cart.fields.shipping_addresses
    ) {
      delete policy.Cart.fields.shipping_addresses.merge
    }

    policy.AvailableShippingMethod = {
      keyFields: false,
    }

    policy.SelectedShippingMethod = {
      keyFields: false,
    }

    return policy
  })

  /**
   * `Supply` is keyed on `uid`; it has no `id`, so Apollo cannot normalise it by default and treats
   * every returned supply as an anonymous object. That meant a mutation returning the updated supply
   * had nowhere to merge into, and the page kept rendering the stale query result until it refetched.
   *
   * Appended as its own entry rather than folded into the loop above, which only mutates policies
   * that already exist and would add nothing to an empty list.
   */
  const supplyPolicies = { Supply: { keyFields: ['uid' as const] } }

  return <Prev {...rest} policies={[...adjustedPolices, supplyPolicies]} />
}

export const Plugin = TempliCartGraphqlProvider
